import {
  Avatar,
  Button,
  Col,
  ColorPicker,
  List,
  Modal,
  Popover,
  Row,
} from "antd";
import PriceInfo from "./PriceInfo";
import "./PriceTut.css";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import { useContext, useEffect, useState } from "react";
import { startPaymentProcess } from "./utils";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";

const exclusive = [
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Infiniti Pazienti",
    description: "Sarà possibile creare pazienti senza alcun limite.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Infiniti Dottori",
    description: "Sarà possibile creare dottori senza alcun limite.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "2048Mb Storage",
    description: "A disposizione 2048Mb di Archiviazione Foto.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Tutti gli Esami Posturali",
    description: "Sarà possibile utilizzare tutti gli esami posturali.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Tutti gli Esami Neurologici",
    description: "Sarà possibile utilizzare tutti gli esami neurologici.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Supporto dell' AI senza Limite",
    description: "Sarà possibile creare report e analizzare foto con AI.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Logo Personalizzato",
    description:
      "Sarà possibile personalizzare tutti i referti con il proprio logo.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Creazione PDF",
    description: "Non sarà possibile creare report in formato PDF.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Assistenza",
    description:
      "Assistenza Exclusive, non avrete accesso all'assistenza veloce a canale diretto.",
  },
  {
    icon: <CheckCircleOutlined className="green-icon" rev={undefined} />,
    title: "Backup",
    description: "Sarà possibile richiedere o scaricare un backup.",
  },
];

declare global {
  interface Window {
    paypal: any;
  }
}

const PriceExclusive: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  const buySubscription = async () => {
    const paymentStartResp = await startPaymentProcess(signedInDoctor, 2);
    console.log(paymentStartResp);

    if (paymentStartResp.error) {
      setError(paymentStartResp.error);
    } else window.location.href = paymentStartResp.url;
  };

  /*
  //Old payment method
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (isModalVisible) {
      const script = document.createElement("script");
      script.src =
        "https://www.paypal.com/sdk/js?client-id=AftFaqh1lTBMnK79zaNt8lYwfLyhh8MJkRtZFThAdFnqpKbhc4h7oEUZxnoe-DsIXGGQ9ta0j41Zt0OS&vault=true&intent=subscription";
      script.async = true;
      script.onload = () => {
        if (window.paypal) {
          window.paypal
            .Buttons({
              style: {
                shape: "pill",
                color: "blue",
                layout: "vertical",
                label: "subscribe",
              },
              createSubscription: function (data: any, actions: any) {
                return actions.subscription.create({
                  plan_id: "P-2EP53165G89013837M2YQH3I", // Assicurati di usare il tuo plan_id
                });
              },
              onApprove: function (data: any, actions: any) {
                alert(data.subscriptionID); // Puoi aggiungere un messaggio di successo opzionale per l'abbonato qui
              },
            })
            .render("#paypal-button-container");
        }
      };
      document.body.appendChild(script);
    }
  }, [isModalVisible]);
  */
  return (
    <>
      <div className="cardos">
        <h2 className="lol11">Exclusive</h2>
        <div className="cardosy">
          <Row className="downly">
            <h2 className="lol1">789</h2>
            <h2 className="lol3">,99</h2>
            <h2 className="lol2">/</h2>
            <h2 className="lol3">Anno</h2>
          </Row>
          <div className="spacedde"></div>

          <List
            itemLayout="horizontal"
            dataSource={exclusive}
            renderItem={(item, index) => (
              <List.Item>
                <List.Item.Meta
                  avatar={item.icon}
                  title={
                    <Popover title={item.description}>{item.title}</Popover>
                  }
                />
              </List.Item>
            )}
          />
          <div className="buybt">
            <Row></Row>
            <Button className="buybtn" onClick={buySubscription}>
              Abbonati
            </Button>
            {error && <div className="error-message">{error}</div>}
          </div>
        </div>
      </div>

      {/* <Modal
        title="Abbonati a Licenza Exclusive"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ margin: "75px" }} id="paypal-button-container"></div>
      </Modal>
      */}
    </>
  );
};

export default PriceExclusive;
